var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomInHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    fill: "#F3EFEF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    stroke: "#450A0A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 15.5V12H15.5V15.5H12V16.5H15.5V20H16.5V16.5H20V15.5H16.5Z",
    fill: "#891515"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomInHover);
export default __webpack_public_path__ + "static/media/zoom-in-hover.19edc8078fbea6743dfde880765af9c0.svg";
export { ForwardRef as ReactComponent };